import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { brandNameFromSettings, brandLogoSrcFromSettings, seoTitleWithBrand } from '../siteBrand';

/**
 * Shared layout for forgot-password / reset-password (matches sign-in page).
 */
export default function AuthPageShell({
  pageTitle,
  asideTitle,
  asideText,
  children,
  footer,
}) {
  const { settings: site } = useSiteSettings();
  const brandName = brandNameFromSettings(site);
  const brandLogo = brandLogoSrcFromSettings(site);

  return (
    <div className="store-auth-page">
      <Helmet>
        <title>{seoTitleWithBrand(pageTitle, brandName)}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="container store-page__container">
        <div className="store-auth-page__grid">
          <aside className="store-auth-aside">
            <div className="store-auth-aside__inner">
              <Link to="/" className="store-auth-aside__brand">
                <img src={brandLogo} alt="" className="store-auth-aside__logo" />
                <span>{brandName}</span>
              </Link>
              <h1 className="store-auth-aside__title">{asideTitle}</h1>
              <p className="store-auth-aside__text">{asideText}</p>
            </div>
          </aside>

          <div className="store-auth-main">
            <div className="store-auth-card">{children}</div>
            {footer ? <div className="store-auth-page__footer mt-3">{footer}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
}
